module.exports = __webpack_public_path__ + "static/media/delivery-bike.21d53c06.svg";